import { jsx as _jsx } from "react/jsx-runtime";
import { ChoiceGroup } from '@fluentui/react';
/** UX for CSAT that renders a 1-5 rating UI */
export const FivePointRatingActionBar = ({ rating, onSelectRatingNumber, }) => (_jsx(ChoiceGroup, { options: ratingOptions, selectedKey: rating, onChange: (_e, option) => onSelectRatingNumber(Number(option === null || option === void 0 ? void 0 : option.key)), label: 'Rating' }));
const ratingOptions = [
    {
        key: '1',
        text: 'Broken',
        iconProps: { iconName: 'Error' },
    },
    {
        key: '2',
        text: 'Bad',
        iconProps: { iconName: 'EmojiDisappointed' },
    },
    {
        key: '3',
        text: 'Below average',
        iconProps: { iconName: 'Sad' },
    },
    {
        key: '4',
        text: 'Average',
        iconProps: { iconName: 'EmojiNeutral' },
    },
    {
        key: '5',
        text: 'Great!',
        iconProps: { iconName: 'Emoji2' },
    },
];
